import { createTheme } from '@one-thd/sui-atomic-components';

const LaborDay2026SecondaryOne = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

LaborDay2026SecondaryOne.palette['--sui-palette-background-primary'] = '128 131 102';

export { LaborDay2026SecondaryOne };